import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MessageService } from '@corelabs/angular-messages';
import { TranslateService } from '@ngx-translate/core';
import { catchError, exhaustMap, map, of, switchMap, tap } from 'rxjs';
import { finalizeLoader } from '@app/shared/components';
import { ToastErrorService } from '@app/shared/services';
import { predefinedPricingTiersActions } from '../actions/predefined-pricing-tiers.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class PredefinedPricingTiersEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);
    private readonly messageService = inject(MessageService);
    private readonly translateService = inject(TranslateService);
    private readonly toastErrorService = inject(ToastErrorService);

    getTiers$ = createEffect(() => {
        return this.actions.pipe(
            ofType(predefinedPricingTiersActions.getTiers),
            exhaustMap(() => {
                return this.httpService.getTiers().pipe(
                    finalizeLoader('predefined-pricing-tiers-list'),
                    map((payload) => predefinedPricingTiersActions.getTiersSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(predefinedPricingTiersActions.getTiersError({ code: response.status }))),
                );
            }),
        );
    });

    saveTiers$ = createEffect(() => {
        return this.actions.pipe(
            ofType(predefinedPricingTiersActions.saveTiers),
            switchMap(({ value }) => {
                return this.httpService.saveTiers(value).pipe(
                    finalizeLoader('predefined-pricing-tiers-save'),
                    map((payload) => predefinedPricingTiersActions.saveTiersSuccess({ payload })),
                    tap(() => this.messageService.add(this.translateService.instant('toast.predefinedPricingTiers.saved'), 'success')),
                    catchError((response: HttpErrorResponse) => {
                        this.toastErrorService.show(response, 'toast.predefinedPricingTiers.saveError');
                        return of(predefinedPricingTiersActions.saveTiersError({ code: response.status }));
                    }),
                );
            }),
        );
    });
}
